module.exports = __webpack_public_path__ + "img/img_27@2x.a9ff8ead.png";